<template>
  <funnel-step-layout anchor="summary">
    <div class="container">
      <div class="row mt-md-5">
        <div class="col-md-6 col-xs-12 mb-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">{{$t('summary.summary_title')}}</h5>
              <div class="card-text text-left">
                <ul>
                  <li>{{$t('summary.entity_label')}} {{$t(`step1.${entity}.label`)}}</li>
                  <li>{{$t(`summary.${selectedGoal}_label`)}} {{selectedObjectivesOrServices}}</li>
                  <li>{{$t('summary.locations_label')}} {{selectedLocations}}</li>
                  <li>{{$t('summary.duration_label')}} {{$t(`step4.months.${inputs.duration}`)}}</li>
                  <li>{{$t('summary.audience_label')}}</li>
                </ul>
              </div>
              <span class="audience-gradient-overlay"></span>
              <px-button data-target="#popinInformationsModal" data-toggle="modal" class="discover-cta" :text="$t('summary.cta_discover')"></px-button>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="row">
            <div class="col-12">
              <iframe v-if="hasVideoURL" id="ytplayer" type="text/html" width="100%" height="340" :src="$t('common.video')" frameborder="0"/>
            </div>
            <div v-if="hasSocialsNetwork" class="col-12 mt-3">
              {{$t('summary.follow_us')}} :
              <span class="align-middle" v-for="(socialURL, id) in structure.socials"
                :key="id">
                <a v-if="socialURL" :href="socialURL" rel="noindex, nofollow" target="_blank"><i :class="['social-network-icon', getSNIcon(id)]"></i></a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal : Cf /screens/Simulation.vue -->
  </funnel-step-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { FunnelStepLayout } from '@/components/Layouts'

export default {
  name: 'step-summary',
  components: {
    FunnelStepLayout
  },
  methods: {
    getSNIcon (network) {
      switch (network) {
        case 'youtube':
          return 'fab fa-youtube-square'
        case 'linkedin':
          return 'fab fa-linkedin'
        case 'instagram':
          return 'fab fa-instagram'
        case 'twitter':
          return 'fab fa-twitter-square'
        case 'facebook':
          return 'fab fa-facebook'
        default:
      }
    }
  },
  computed: {
    ...mapGetters({
      structure: 'form/summary_structure',
      goal: 'form/goal',
      entity: 'form/entity',
      inputs: 'form/inputs',
      lang: 'lang',
      audience: 'form/audience'
    }),
    hasVideoURL () {
      return this.$t('common.video').startsWith('http')
    },
    selectedObjectivesOrServices () {
      // const selected = []

      return this.inputs.objectives_services.map(id => this.$t(`step2.${this.entity}.${this.goal}.${id}.title`)).join(', ')

      // for (let i = 0; i < this.inputs.objectives_services.length; i++) {
      //   selected.push(this.$t(`step2.${this.entity}.${this.goal}.${this.inputs.objectives_services[i]}.title`))
      // }
      // return selected.join(', ')
    },
    selectedLocations () {
      // TODO: Refactor -> map().join() + limit (ex: + 34 villes)
      const locations = []
      for (let i = 0; i < this.inputs.locations.cities.length; i++) {
        locations.push(this.inputs.locations.cities[i][`name_${this.lang}`])
      }
      for (let i = 0; i < this.inputs.locations.countries.length; i++) {
        locations.push(this.inputs.locations.countries[i][`name_${this.lang}`])
      }
      return locations.join(', ')
    },
    selectedGoal () {
      if (this.goal === 'objectives') {
        return 'objective'
      }
      return 'service'
    },
    hasSocialsNetwork () {
      if (this.structure.socials) {
        return Object.values(this.structure.socials).some(url => url.length)
      }
      return false
    }
  }
}
</script>
